import { cn } from "@/lib/utils";
import React from "react";

export default function Heading({
  level = 1,
  children,
  className,
  ...props
}: React.ComponentPropsWithRef<"h1"> & {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
}) {
  function getClassNames() {
    switch (level) {
      case 1:
        return "text-4xl";
      case 2:
        return "text-3xl";
      case 3:
        return "text-lg";
      case 4:
        return "text-base";
      case 5:
        return "text-sm";
      case 6:
        return "text-xs";
      default:
        return "text-2xl";
    }
  }

  return React.createElement(
    `h${level}`,
    {
      ...props,
      className: cn(
        "font-bold text-[var(--black)] dark:text-[var(--text-primary)] tracking-tighter",
        getClassNames(),
        className
      ),
    },
    children
  );
}
